const ENTRY_STEP = 'ENTRY';
const PREFERENCE_STEP = 'PREFERENCE';
const NOMINATION_STEP = 'NOMINATION';

export { ENTRY_STEP, PREFERENCE_STEP, NOMINATION_STEP };
